import { render } from "./app.vue?vue&type=template&id=8ce8dfa0"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./design/styleOverrides.scss?vue&type=style&index=0&lang=scss&external"
import "./app.vue?vue&type=style&index=1&id=8ce8dfa0&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__